import { render } from "./EditProfile.vue?vue&type=template&id=2812c00e&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=2812c00e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2812c00e"]])

export default __exports__